import { call, put, takeLatest } from 'redux-saga/effects';

import { linksAddItemRequest, linksDeleteItemRequest, linksUpdateError, linksUpdateItemRequest, linksUpdateRequest, linksUpdateStore } from './linksActions.js';
import { addLinksItemApiCall, deleteLinksItemApiCall, updateLinksBlockApiCall, updateLinksItemApiCall } from './linksAPI.js';

function* updateLinksSaga({ payload }) {
  try {
    yield call(updateLinksBlockApiCall, payload);
    yield put(linksUpdateStore());
  } catch (error) {
    yield put(linksUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* addLinksItemSaga({ payload }) {
  try {
    yield call(addLinksItemApiCall, payload);
    yield put(linksUpdateStore());
  } catch (error) {
    yield put(linksUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* updateLinksItemSaga({ payload }) {
  try {
    const { id, ...data } = payload;
    yield call(updateLinksItemApiCall, id, data);
    yield put(linksUpdateStore());
  } catch (error) {
    yield put(linksUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* deleteLinksItemSaga({ payload }) {
  try {
    yield call(deleteLinksItemApiCall, payload);
    yield put(linksUpdateStore());
  } catch (error) {
    yield put(linksUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsLinksWatcher() {
  yield takeLatest(linksUpdateRequest.type, updateLinksSaga);
  yield takeLatest(linksAddItemRequest.type, addLinksItemSaga);
  yield takeLatest(linksUpdateItemRequest.type, updateLinksItemSaga);
  yield takeLatest(linksDeleteItemRequest.type, deleteLinksItemSaga);
}
